import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../../common/store/types';
import {
  CommissionModel,
  CommissionPreviewModel,
  CommissionReportModel,
  CommissionReportSalesPersonCommissionsDashboardModel,
  CommissionReportSalesPersonProductionDashboardModel,
} from './types';
import { commissionActions } from './commission.actions';

export interface ICommissionState extends IState<CommissionModel> {
  getById: GenericState<CommissionModel>;
  getCommissionsPreview: GenericState<CommissionPreviewModel[]>;
  add: GenericState<CommissionPreviewModel[]>;
  addSalesPersonCommissionPayment: GenericState<boolean>;
  deleteSalesPersonCommissions: GenericState<boolean>;
  deleteSalesPersonCommissionPayment: GenericState<boolean>;
  getCompanyCommissions: GenericState<CommissionReportModel[]>;
  getExcludedTaxAnnualFees: GenericState<CommissionReportModel[]>;
  getApplicationFeesReport: GenericState<CommissionReportModel[]>;
  getSalesPersonProductionDashboardData: GenericState<CommissionReportSalesPersonProductionDashboardModel>;
  getSalesPersonCommissionsDashboardData: GenericState<CommissionReportSalesPersonCommissionsDashboardModel>;
}

export const commissionInitialState: ICommissionState = {
  getById: new GenericState<CommissionModel>(),
  getCommissionsPreview: new GenericState<CommissionPreviewModel[]>(),
  add: new GenericState<CommissionPreviewModel[]>(),
  addSalesPersonCommissionPayment: new GenericState<boolean>(),
  deleteSalesPersonCommissions: new GenericState<boolean>(),
  deleteSalesPersonCommissionPayment: new GenericState<boolean>(),
  getCompanyCommissions: new GenericState<CommissionReportModel[]>(),
  getExcludedTaxAnnualFees: new GenericState<CommissionReportModel[]>(),
  getApplicationFeesReport: new GenericState<CommissionReportModel[]>(),
  getSalesPersonProductionDashboardData:
    new GenericState<CommissionReportSalesPersonProductionDashboardModel>(),
  getSalesPersonCommissionsDashboardData:
    new GenericState<CommissionReportSalesPersonCommissionsDashboardModel>(),
};

const commissionReducers = [
  ...onApiCall<CommissionModel>(commissionActions.getById, 'getById'),
  ...onApiCall<CommissionPreviewModel[]>(
    commissionActions.getCommissionsPreview,
    'getCommissionsPreview',
  ),
  ...onApiCall<CommissionPreviewModel[]>(commissionActions.add, 'add'),
  ...onApiCall<boolean>(
    commissionActions.addSalesPersonCommissionPayment,
    'addSalesPersonCommissionPayment',
  ),
  ...onApiCall<boolean>(
    commissionActions.deleteSalesPersonCommissions,
    'deleteSalesPersonCommissions',
  ),
  ...onApiCall<boolean>(
    commissionActions.deleteSalesPersonCommissionPayment,
    'deleteSalesPersonCommissionPayment',
  ),
  ...onApiCall<CommissionReportModel[]>(
    commissionActions.getCompanyCommissions,
    'getCompanyCommissions',
  ),
  ...onApiCall<CommissionReportModel[]>(
    commissionActions.getExcludedTaxAnnualFees,
    'getExcludedTaxAnnualFees',
  ),
  ...onApiCall<CommissionReportModel[]>(
    commissionActions.getApplicationFeesReport,
    'getApplicationFeesReport',
  ),
  ...onApiCall<CommissionReportSalesPersonProductionDashboardModel>(
    commissionActions.getSalesPersonProductionDashboardData,
    'getSalesPersonProductionDashboardData',
  ),
  ...onApiCall<CommissionReportSalesPersonCommissionsDashboardModel>(
    commissionActions.getSalesPersonCommissionsDashboardData,
    'getSalesPersonCommissionsDashboardData',
  ),
];

export const commissionReducer = createReducer(
  commissionInitialState,
  ...commissionReducers,
) as ActionReducer<ICommissionState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return commissionReducer(state, action);
}
